// src/components/states/bremen.js
export const bremen = {
  slug: "bremen",
  name: "Bremen",
  hero: {
    eyebrow: "Bundesland-Übersicht",
    title: "Erdwärme in Bremen",
    subtitle:
      "Übersicht zu Förderung, wasserrechtlichem Verfahren, bergrechtlichen Hinweisen, Leitfaden und typischen Standortfaktoren für Bremen und Bremerhaven – kompakt und praxisnah.",
    infoBox:
      "Bremen stellt die Erdwärmenutzung klar dar: Für Errichtung und Betrieb einer Erdwärmegewinnungsanlage ist in der Regel eine wasserrechtliche Erlaubnis notwendig; zusätzlich gibt es bergrechtliche Hinweise und einen aktuellen Leitfaden.",
  },
  seo: {
    title:
      "Erdwärme in Bremen – Förderung, Genehmigung & Leitfaden | Erdwärme-Experten",
    description:
      "Kurzübersicht Erdwärme Bremen: KfW-Förderung, wasserrechtliche Erlaubnis, bergrechtliche Hinweise, Leitfaden oberflächennahe Geothermie im Land Bremen und typische Standortfaktoren.",
    canonical: "https://www.erdwaerme-experten.de/bundeslaender/bremen",
  },

  facts: [
    {
      title: "Förderung (Bund)",
      icon: "BadgeCheck",
      color: "from-rose-600 to-rose-500",
      bullets: [
        "Heizungstausch-Zuschuss über KfW Programm 458 für Bestandsgebäude",
        "30 % Grundförderung; persönliche Boni können die Quote erhöhen",
        "Maximal 80 %; kein separater Effizienzbonus für Erdwärme",
      ],
      note:
        "Förderstand 21.07.2026. Die tatsächliche Förderfähigkeit hängt von Gebäude, Eigentum, Einkommen und weiteren Voraussetzungen ab.",
      link: {
        label: "KfW 458 (offiziell)",
        href: "https://www.kfw.de/inlandsfoerderung/Privatpersonen/Bestehende-Immobilie/F%C3%B6rderprodukte/Heizungsf%C3%B6rderung-f%C3%BCr-Privatpersonen-Wohngeb%C3%A4ude-%28458%29/",
      },
    },
    {
      title: "Wasserrechtliche Erlaubnis",
      icon: "ShieldCheck",
      color: "from-slate-700 to-slate-600",
      bullets: [
        "Errichtung und Betrieb einer Erdwärmegewinnungsanlage bedürfen in Bremen einer behördlichen Erlaubnis bzw. Bewilligung nach Wasserrecht.",
        "Begründet wird das mit möglichen Einwirkungen auf das Grundwasser.",
        "Die Wasserbehörde Bremen stellt dafür Informationen und einen Antrag bereit.",
      ],
      note:
        "Für Bremen ist das wasserrechtliche Verfahren der zentrale Genehmigungsschritt.",
      link: {
        label: "Bremen: Informationen zur Erdwärmenutzung",
        href: "https://umwelt.bremen.de/umwelt/wasser/informationen-zur-erdwaermenutzung-23537",
      },
    },
    {
      title: "Bergrecht – was ist relevant?",
      icon: "Drill",
      color: "from-indigo-700 to-indigo-600",
      bullets: [
        "Erdwärme gilt grundsätzlich als bergfreier Bodenschatz.",
        "Für die Aufsuchung ist grundsätzlich eine Erlaubnis und für die Gewinnung eine Bewilligung nach BBergG vorgesehen.",
        "Eine Bewilligung ist in der Regel nicht erforderlich, wenn die Nutzung bis 30 kW für Ein- oder Zweifamilienhäuser auf einem Grundstück erfolgt und 5 m Abstand zur Grundstücksgrenze eingehalten werden.",
      ],
      note:
        "Für kleine typische Wohngebäude-Projekte ist das bergrechtlich oft entschärft, die Einzelfallprüfung bleibt aber wichtig.",
      link: {
        label: "Bremen: bergrechtliche Hinweise",
        href: "https://umwelt.bremen.de/umwelt/wasser/informationen-zur-erdwaermenutzung-23537",
      },
    },
    {
      title: "Leitfaden & Antrag",
      icon: "FileText",
      color: "from-emerald-700 to-emerald-600",
      bullets: [
        "Bremen verweist auf den Leitfaden „Oberflächennahe Geothermie im Land Bremen“.",
        "Zusätzlich ist ein Antrag auf Erlaubnis zur Errichtung einer Erdwärmegewinnungsanlage verlinkt.",
        "Die Informationen sind auf der Umwelt-Seite des Landes gebündelt.",
      ],
      note:
        "Das ist für deine Bundesländer-Seite sehr gut, weil Nutzer direkt sehen, wie sie vom Interesse in ein reales Verfahren kommen.",
      link: {
        label: "Bremen: Leitfaden & Antrag",
        href: "https://umwelt.bremen.de/umwelt/wasser/informationen-zur-erdwaermenutzung-23537",
      },
    },
  ],

  dataCards: [
    {
      title: "Welche Daten sind verfügbar?",
      icon: "Layers",
      desc:
        "Bremen bündelt Leitfaden, wasserrechtliche Informationen und Antragsunterlagen zentral. Das eignet sich gut für eine erste praktische Vorprüfung.",
    },
    {
      title: "Was ist häufig der Engpass?",
      icon: "Droplets",
      desc:
        "Der Schutz des Grundwassers ist in Bremen ein zentraler Prüfpunkt. Deshalb ist die wasserrechtliche Erlaubnis für viele Vorhaben entscheidend.",
    },
    {
      title: "Was macht euer GeoReport daraus?",
      icon: "FileText",
      desc:
        "Der GeoReport verbindet Standortinformationen mit einer ersten technischen Einordnung und hilft, Machbarkeit, Aufwand und nächste Schritte besser abzuschätzen.",
    },
  ],

  faq: [
    {
      q: "Brauche ich in Bremen eine wasserrechtliche Erlaubnis?",
      a: "Ja, in Bremen ist für Errichtung und Betrieb einer Erdwärmegewinnungsanlage grundsätzlich eine behördliche Erlaubnis erforderlich, weil Eingriffe in das Grundwasser als Benutzung des Gewässers eingeordnet werden können.",
      links: [
        {
          label: "Bremen: Informationen zur Erdwärmenutzung",
          href: "https://umwelt.bremen.de/umwelt/wasser/informationen-zur-erdwaermenutzung-23537",
        },
      ],
    },
    {
      q: "Spielt Bergrecht in Bremen eine Rolle?",
      a: "Ja, Bremen weist darauf hin, dass Erdwärme grundsätzlich als bergfreier Bodenschatz gilt. Für kleine typische Wohngebäudeanlagen auf dem eigenen Grundstück ist eine bergrechtliche Bewilligung aber in der Regel nicht erforderlich, wenn bestimmte Bedingungen erfüllt sind, etwa bis 30 kW und mindestens 5 m Abstand zur Grundstücksgrenze.",
      links: [
        {
          label: "Bremen: bergrechtliche Hinweise",
          href: "https://umwelt.bremen.de/umwelt/wasser/informationen-zur-erdwaermenutzung-23537",
        },
      ],
    },
    {
      q: "Gibt es in Bremen einen Leitfaden oder Antrag?",
      a: "Ja. Auf der Bremer Umwelt-Seite sind sowohl der Leitfaden „Oberflächennahe Geothermie im Land Bremen“ als auch der Antrag auf Erlaubnis zur Errichtung einer Erdwärmegewinnungsanlage verlinkt.",
      links: [
        {
          label: "Bremen: Leitfaden & Antrag",
          href: "https://umwelt.bremen.de/umwelt/wasser/informationen-zur-erdwaermenutzung-23537",
        },
      ],
    },
  ],

  cta: {
    title: "Bremen-Standort prüfen (datenbasiert)",
    text:
      "Du bekommst eine standortbezogene Vorabschätzung: erste technische Einordnung, Hinweise zu Genehmigung und Untergrund sowie eine bessere Grundlage für die weitere Planung.",
    primary: {
      label: "Jetzt Standort-Report erstellen",
      href: "/report",
      title: "Erdwärme Standort-Report für Bremen erstellen",
    },
    secondary: { label: "Erst Grundlagen ansehen", href: "/flache-geothermie" },
    footnote:
      "Tipp: In Bremen lohnt sich vorab der Blick in den offiziellen Leitfaden und die Hinweise der Wasserbehörde.",
  },
};